import { useSelector } from 'react-redux';
import { isBaseSubscription } from 'reactApp/modules/billingData/billingData.types';
import { isSubscriptionRenewable } from 'reactApp/modules/billingData/billingData.utils';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import type { RootState } from 'reactApp/store';
import type { Subscription } from 'reactApp/ui/Mobile/SubscriptionsModal/SubscriptionsModal.types';

export const renderSubscriptionInfoModal = (data: {
    subscription: Subscription;
    isRebrandingQuotaLanding?: boolean;
    isRebranding?: boolean;
}) => openPopupHelper({ popupName: popupNames.SUBSCRIPTION_INFO_MOBILE, data });

export const useCanCheckDiscounts = (subscription: Subscription) => {
    const product = useSelector((state: RootState) => ProductsSelectors.getProductById(state, subscription?.['productId']));

    if (isBaseSubscription(subscription)) {
        return false;
    }

    return product && isSubscriptionRenewable(subscription, true);
};
